import { ChangeDetectionStrategy, Component } from '@angular/core';
import { filter, map, merge, of, switchMap } from 'rxjs';
import { WebsocketService } from '@shared/services/websocket.service';
import { InvoiceProcessingService } from '@shared/services/invoice-processing.service';
import {
  TuiButtonModule,
  TuiDataListModule,
  TuiHostedDropdownModule,
} from '@taiga-ui/core';
import { TuiLetModule } from '@taiga-ui/cdk';
import { AsyncPipe, DatePipe } from '@angular/common';
import { InvoiceProcessStatus } from '../../../../../../types/invoice-process';
import { WebsocketEvent } from '../../../../../../types/websocket';

@Component({
  selector: 'app-accounting-processes',
  standalone: true,
  imports: [
    TuiButtonModule,
    TuiDataListModule,
    TuiHostedDropdownModule,
    TuiLetModule,
    AsyncPipe,
    DatePipe,
  ],
  templateUrl: './accounting-processes.component.html',
  styleUrl: './accounting-processes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountingProcessesComponent {
  processes$ = merge(
    of(null),
    this.ws.invoicesEvents$.pipe(
      filter(
        ws =>
          ws.event ===
          WebsocketEvent.INVOICE_ACCOUNTING_PROCESSING_CHANGE_STATUS,
      ),
    ),
  ).pipe(
    switchMap(() =>
      this.ips.getAccounting().pipe(map(items => items.reverse())),
    ),
  );

  pendingProcesses$ = this.processes$.pipe(
    map(processes =>
      processes.filter(p => p.status === InvoiceProcessStatus.PENDING),
    ),
  );

  activeProcesses$ = this.processes$.pipe(
    map(processes =>
      processes.filter(p => p.status === InvoiceProcessStatus.PROCESSING),
    ),
  );

  errorProcesses$ = this.processes$.pipe(
    map(processes =>
      processes.filter(p => p.status === InvoiceProcessStatus.ERROR),
    ),
  );

  protected readonly InvoiceProcessingService = InvoiceProcessingService;
  protected readonly InvoiceProcessStatus = InvoiceProcessStatus;
  constructor(
    private readonly ws: WebsocketService,
    private readonly ips: InvoiceProcessingService,
  ) {}
}
